import React from "react"
import {FormattedMessage} from "react-intl"


export function LandingHeaderOurStory() {
    return (
        <div className="our-story">

            <h2><FormattedMessage id="landing.slider.card2.story"/></h2>

            <div className="our-story-image">
                <img src="https://cdn.gedcomcreator.com/assets/no-tools.png" alt="No tools"/>
            </div>

            <div className="our-story-text">
                {/* NO TOOLS */}
                <p><FormattedMessage id="landing.slider.card2.unsatisfied"/></p>
                <ul>
                    <li><FormattedMessage id="landing.slider.card2.desktop"/></li>
                    <li><FormattedMessage id="landing.slider.card2.websites" values={{ break: <br/> }}/></li>
                </ul>
                {/* BUILD OUR OWN */}
                <p style={{ fontWeight: "bold" }}><FormattedMessage id="landing.slider.card2.custom"/></p>
            </div>
        </div>
    )
}